import { stringify } from 'querystring';
import { fetchJSON } from '@catalogo/core-http';
import { removeUndef } from '@catalogo/core-helpers/utils';
import { readCookies } from '@catalogo/core-connect/cookies';

const getPlacementSize = placement => {
  switch (placement) {
    case 'search.middle':
      return { size: 1 };
    case 'category.1':
      return { size: 2 };
    case 'search.1':
      return { size: 2 };
    case 'keyword.search.1':
      return { size: 4 };
    default:
      return {};
  }
};

const buildUrl = (placements, productId, userId, term, context, b2wRegion, brand, categoryId) => {
  const url = `https://apiadapter.ad5track.com/v3/ads/${brand}`;

  const params = removeUndef({
    size: 20,
    uid: userId,
    context,
    term,
    c_b2wRegion: b2wRegion,
    productId,
    category_id: categoryId,
    placements: `{${placements.map(p => `"${p}":${JSON.stringify(getPlacementSize(p))}`).join(',')}}`,
    referrer: window.location.href,
  });

  return `${url}?${stringify(params)}`;
};

const formatDataKeyword = (item, shelf) => {
  if (item === 'keyword.search.1') {
    return {
      keywordId: shelf.keyword_id,
      impressionId: shelf.impression_id,
      impressionTrackingUrl: shelf.impression_tracking_url,
      storeUrl: shelf.store_url,
      sponsorName: shelf.sponsored_by,
      title: shelf.headline,
      headline: shelf.store_url_headline,
      sponsorImage: shelf.headline_image_url,
      trackingUrl: shelf.click_tracking_url,
    };
  }
};

const formatProduct = (item, product) => {
  if (item === 'keyword.search.1') {
    return {
      id: product.id,
      sellerId: product.seller_id,
      key: product.chave,
      queryString: product.queryString,
      trackingUrl: product.click_tracking_url,
      impressionId: product.impression_id,
      impressionTrackingUrl: product.impression_tracking_url,
    };
  }

  return {
    id: product.id,
    sellerId: product.seller_id,
    key: product.chave,
    queryString: product.queryString,
    trackingUrl: product.url,
  };
};

export default (config, cache) => async (_, args) => {
  const { cookies } = readCookies(cache);
  const { 'B2W-UID': userId, b2wRegion } = cookies;
  const { brandNameLower } = config;

  if (!args.placements || args.placements.length < 1) {
    return {};
  }

  try {
    const response = await fetchJSON(
      buildUrl(
        args.placements,
        args.productId,
        userId,
        args.term,
        args.pageType,
        b2wRegion,
        brandNameLower,
        args.categoryId
      )
    );
    return args.placements.reduce((prev, item) => {
      const shelf = response[item];
      if (shelf.products.length < 1) {
        return prev;
      }

      prev[item] = {
        title: shelf.title,
        type: 'carousel',
        ...formatDataKeyword(item, shelf),
        products: shelf.products.map(product => formatProduct(item, product)),
      };
      return prev;
    }, {});
  } catch (e) {
    return {};
  }
};
